import React from 'react';
import './ProgressBar.css';

const ProgressBar = ({ stages, currentStage }) => (
  <div className="progress-bar">
    {stages.map((stage, index) => (
      <div
        key={stage.key}
        className={`progress-step ${index <= currentStage ? 'complete' : ''}`}
      >
        <div className="step-marker">{index + 1}</div>
        <div className="step-label">{stage.label}</div>
        {index < stages.length - 1 && <div className="step-bar" />}
      </div>
    ))}
  </div>
);

export default ProgressBar;
